import React, { useCallback, useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import DownloadIcon from '@mui/icons-material/Download';
import CardContent from '@mui/material/CardContent';
import { Button, Typography } from "@mui/material";
import { cleanBorder, primary45 } from "utils/colors";
import { useSnackbar } from "../components/snackbar";
import { uploadCSV, getCSVUploadCount } from "api/users";

const Drop = ({ onLoaded }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [csvFile, setCsvFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploadCount, setuploadCount] = useState(null);
  const styles = {
    container: {
      textAlign: "center",
      border: cleanBorder,
      padding: 100,
      color: primary45,
      fontSize: 18,
      fontWeight: 600,
      borderRadius: 4,
      userSelect: "none",
      outline: 0,
      cursor: "pointer",
      width: "100%",
    },
  };

  const onDrop = useCallback((acceptedFiles) => {
    const csvFiles = acceptedFiles.filter((file) => file.type === "text/csv");
    if (csvFiles.length) {
      console.log("CSV file accepted:", csvFiles[0]);
      setCsvFile(csvFiles[0]);
    } else {
      enqueueSnackbar("Please insert a valid CSV file", { variant: "error" });
    }
  }, [enqueueSnackbar]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "text/csv": [".csv"] },
  });
  useEffect(() => {
    uploadData();
  }, []);
  

  const uploadData = async () => {
    const response = await getCSVUploadCount();
    setuploadCount(response);
  };

  const handleUpload = async () => {
    if (!csvFile) return;

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", csvFile);
      console.log("file form data", formData)
      const response = await uploadCSV(formData);
      enqueueSnackbar("CSV uploaded successfully!", { variant: "success" });
      setCsvFile(null);
      uploadData();
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Failed to upload CSV", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Typography variant="h4" gutterBottom>
       Upload ILead Contacts
      </Typography>
      <Card sx={{ padding: 3 }}>
        {uploadCount ? (
          <div>
            <p><strong>Last upload at:</strong> {new Date(uploadCount.latestUploadAt).toLocaleString()}</p>
            <p>
              <strong>File:</strong>{' '}
              <a
                href={uploadCount.filePath}
                target="_blank"
                rel="noopener noreferrer"
                download
                style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
              >
                Download CSV File <DownloadIcon fontSize="small" />
              </a>
            </p>
            <p><strong>Total contacts in CSV:</strong> {uploadCount.total_count || 0}</p>
            <p><strong>Updated in ILead:</strong> {uploadCount.count}</p>
            <p><strong>Uploaded by:</strong> {uploadCount.uploadedBy}</p>
          </div>
        ) : (
          <></>
        )}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div {...getRootProps()} style={styles.container}>
              <input {...getInputProps()} />
              {isDragActive ? (
                <Typography>Drop a CSV file here</Typography>
              ) : (
                <Typography>Drag and drop a CSV file here</Typography>
              )}
            </div>
          </Grid>

          {csvFile && (
            <Grid item xs={12}>
              <Card sx={{ marginTop: 2, padding: 2, textAlign: "center" }}>
                <Typography variant="h6">{csvFile.name}</Typography>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ marginTop: 2 }}
                  onClick={handleUpload}
                  disabled={loading}
                >
                  {loading ? "Uploading..." : "Upload CSV"}
                </Button>
              </Card>
            </Grid>
          )}
        </Grid>
      </Card>
    </>
  );
};

export default Drop;
